import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import RoomContext from '../lib/RoomClientContext';
import { toggleHideVideo, toggleMuted } from '../store/slices/controlSlice';
import { setViewLayout } from '../store/slices/layoutSlice';

export default function useControls() {
  const roomClient = useContext(RoomContext);
  const dispatch = useDispatch();

  const onToggleMute = useCallback(() => {
    dispatch(toggleMuted());
  }, [dispatch]);

  const onToggleVideo = useCallback(() => {
    dispatch(toggleHideVideo());
  }, [dispatch]);

  const onRaiseHand = useCallback(() => {
    roomClient.onRaiseHand();
  }, [roomClient]);

  const onPeerMute = useCallback(
    (peer) => {
      roomClient.onPeerMute(peer);
    },
    [roomClient]
  );

  const onToggleScreenShare = useCallback(
    (forceStop = false, file = null) => {
      roomClient.onToggleScreenShare(forceStop, file);
    },
    [roomClient]
  );

  const onSetViewLayout = useCallback(
    (option) => {
      dispatch(setViewLayout(option));
      roomClient.preShareLayout = null;
    },
    [dispatch, setViewLayout, roomClient]
  );

  const onToggleRecording = useCallback(
    (details) => {
      roomClient.onToggleRecording(details);
    },
    [roomClient]
  );

  const onCloseSettings = useCallback(
    (newSettings) => {
      roomClient.onCloseSettings(newSettings);
    },
    [roomClient]
  );

  const onLeave = useCallback(() => {
    roomClient.onLeave();
  }, [roomClient]);

  const onForceLowerHand = useCallback(
    (peer) => {
      roomClient.onPeerForceLowerHand(peer);
    },
    [roomClient]
  );

  return {
    onToggleMute,
    onToggleVideo,
    onRaiseHand,
    onPeerMute,
    onToggleScreenShare,
    onSetViewLayout,
    onToggleRecording,
    onCloseSettings,
    onLeave,
    onForceLowerHand,
  };
}
